module.exports = __webpack_public_path__ + "img/chengyun22.6986364a.png";